import { makeConstantFactory } from 'utils/constantsHelper'
const makeConstant = makeConstantFactory('inbox')

export const FETCH_INBOX = makeConstant('FETCH_INBOX')
export const FETCH_INBOX_PENDING = makeConstant('FETCH_INBOX_PENDING')
export const FETCH_INBOX_CANCELLED = makeConstant('FETCH_INBOX_CANCELLED')
export const FETCH_INBOX_FAILED = makeConstant('FETCH_INBOX_FAILED')
export const RECEIVE_INBOX = makeConstant('RECEIVE_INBOX')

export const BULK_CLOSE_FOR_INBOX = makeConstant('BULK_CLOSE_FOR_INBOX')
export const BULK_CLOSE_FOR_INBOX_REQUESTED = makeConstant('BULK_CLOSE_FOR_INBOX_REQUESTED')
export const BULK_CLOSE_FOR_INBOX_FAILED = makeConstant('BULK_CLOSE_FOR_INBOX_FAILED')

export const FETCH_INBOX_LIST = makeConstant('FETCH_INBOX_LIST')
export const FETCH_INBOX_LIST_PENDING = makeConstant('FETCH_INBOX_LIST_PENDING')
export const FETCH_INBOX_LIST_CANCELLED = makeConstant('FETCH_INBOX_LIST_CANCELLED')
export const FETCH_INBOX_LIST_FAILED = makeConstant('FETCH_INBOX_LIST_FAILED')
export const RECEIVE_INBOX_LIST = makeConstant('RECEIVE_INBOX_LIST')

export const FETCH_COUNTS_FOR_INBOX_IDS = makeConstant('FETCH_COUNTS_FOR_INBOX_IDS')
export const FETCH_COUNTS = makeConstant('FETCH_COUNTS')
export const FETCH_COUNTS_PENDING = makeConstant('FETCH_COUNTS_PENDING')
export const FETCH_COUNTS_CANCELLED = makeConstant('FETCH_COUNTS_CANCELLED')
export const FETCH_COUNTS_FAILED = makeConstant('FETCH_COUNTS_FAILED')
export const RECEIVE_COUNTS = makeConstant('RECEIVE_COUNTS')
export const RECEIVE_COUNTS_2 = makeConstant('RECEIVE_COUNTS_2')
export const CHANGE_STATUS = makeConstant('CHANGE_STATUS')
export const BULK_CHANGE_STATUS = makeConstant('BULK_CHANGE_STATUS')
export const CHANGE_PARTICIPANTS = makeConstant('CHANGE_PARTICIPANTS')

export const INBOX_REDIRECT = makeConstant('INBOX_REDIRECT')

export const INBOX_CHANGED = makeConstant('INBOX_CHANGED')
export const INBOX_REGEX = /inboxes\/?(\d+)?/

export const FETCH_WHITELABEL = makeConstant('FETCH_WHITELABEL')
export const FETCH_WHITELABEL_PENDING = makeConstant('FETCH_WHITELABEL_PENDING')
export const FETCH_WHITELABEL_FAILED = makeConstant('FETCH_WHITELABEL_FAILED')
export const FETCH_WHITELABEL_SUCCESS = makeConstant('FETCH_WHITELABEL_SUCCESS')
export const FETCH_WHITELABEL_CANCELLED = makeConstant('FETCH_WHITELABEL_CANCELLED')

export const CREATE_INBOX_BEFORE_WHITELABEL = makeConstant('CREATE_INBOX_BEFORE_WHITELABEL')
export const CREATE_WHITELABEL = makeConstant('CREATE_WHITELABEL')
export const CREATE_WHITELABEL_PENDING = makeConstant('CREATE_WHITELABEL_PENDING')
export const CREATE_WHITELABEL_FAILED = makeConstant('CREATE_WHITELABEL_FAILED')
export const CREATE_WHITELABEL_SUCCESS = makeConstant('CREATE_WHITELABEL_SUCCESS')
export const CREATE_WHITELABEL_CANCELLED = makeConstant('CREATE_WHITELABEL_CANCELLED')

export const VERIFY_WHITELABEL = makeConstant('VERIFY_WHITELABEL')
export const VERIFY_WHITELABEL_PENDING = makeConstant('VERIFY_WHITELABEL_PENDING')
export const VERIFY_WHITELABEL_FAILED = makeConstant('VERIFY_WHITELABEL_FAILED')
export const VERIFY_WHITELABEL_SUCCESS = makeConstant('VERIFY_WHITELABEL_SUCCESS')
export const VERIFY_WHITELABEL_CANCELLED = makeConstant('VERIFY_WHITELABEL_CANCELLED')

export const OPEN_WHITELABEL_DKIM_SETTING = makeConstant('OPEN_WHITELABEL_DKIM_SETTING')
export const CLOSE_WHITELABEL_DKIM_SETTING = makeConstant('CLOSE_WHITELABEL_DKIM_SETTING')

export const CREATE_INBOX = makeConstant('CREATE_INBOX')
export const CREATE_INBOX_PENDING = makeConstant('CREATE_INBOX_PENDING')
export const CREATE_INBOX_FAILED = makeConstant('CREATE_INBOX_FAILED')
export const CREATE_INBOX_SUCCESS = makeConstant('CREATE_INBOX_SUCCESS')
export const CREATE_INBOX_CANCELLED = makeConstant('CREATE_INBOX_CANCELLED')

export const FETCH_SENDING_DOMAINS = makeConstant('FETCH_SENDING_DOMAINS')
export const FETCH_SENDING_DOMAINS_PENDING = makeConstant('FETCH_SENDING_DOMAINS_PENDING')
export const FETCH_SENDING_DOMAINS_FAILED = makeConstant('FETCH_SENDING_DOMAINS_FAILED')
export const FETCH_SENDING_DOMAINS_SUCCESS = makeConstant('FETCH_SENDING_DOMAINS_SUCCESS')

export const CREATE_SENDING_DOMAIN = makeConstant('CREATE_SENDING_DOMAIN')
export const CREATE_SENDING_DOMAIN_PENDING = makeConstant('CREATE_SENDING_DOMAIN_PENDING')
export const CREATE_SENDING_DOMAIN_FAILED = makeConstant('CREATE_SENDING_DOMAIN_FAILED')
export const CREATE_SENDING_DOMAIN_FAILED_NO_USER = makeConstant('CREATE_SENDING_DOMAIN_FAILED_NO_USER')
export const CREATE_SENDING_DOMAIN_SUCCESS = makeConstant('CREATE_SENDING_DOMAIN_SUCCESS')

export const VERIFY_SENDING_DOMAIN = makeConstant('VERIFY_SENDING_DOMAIN')
export const VERIFY_SENDING_DOMAIN_PENDING = makeConstant('VERIFY_SENDING_DOMAIN_PENDING')
export const VERIFY_SENDING_DOMAIN_FAILED = makeConstant('VERIFY_SENDING_DOMAIN_FAILED')
export const VERIFY_SENDING_DOMAIN_SUCCESS = makeConstant('VERIFY_SENDING_DOMAIN_SUCCESS')

export const DELETE_SENDING_DOMAIN = makeConstant('DELETE_SENDING_DOMAIN')
export const DELETE_SENDING_DOMAIN_PENDING = makeConstant('DELETE_SENDING_DOMAIN_PENDING')
export const DELETE_SENDING_DOMAIN_FAILED = makeConstant('DELETE_SENDING_DOMAIN_FAILED')
export const DELETE_SENDING_DOMAIN_SUCCESS = makeConstant('DELETE_SENDING_DOMAIN_SUCCESS')

export const PATCH_INBOX = makeConstant('PATCH_INBOX')
export const PATCH_INBOX_PENDING = makeConstant('PATCH_INBOX_PENDING')
export const PATCH_INBOX_FAILED = makeConstant('PATCH_INBOX_FAILED')
export const PATCH_INBOX_SUCCESS = makeConstant('PATCH_INBOX_SUCCESS')

export const ARCHIVE_INBOX = makeConstant('ARCHIVE_INBOX')
export const ARCHIVE_INBOX_PENDING = makeConstant('ARCHIVE_INBOX_PENDING')
export const ARCHIVE_INBOX_FAILED = makeConstant('ARCHIVE_INBOX_FAILED')
export const ARCHIVE_INBOX_SUCCESS = makeConstant('ARCHIVE_INBOX_SUCCESS')



// WEBPACK FOOTER //
// ./src/scripts/app/modules/inbox/constants.js